// a siteHeader z-index-et allitja scrollozastol fuggoen, hogy ne latszodjon/latszodjon a footer 
const siteHeaderZIndex =()=> {

    const identity = "Header Z-index";

    //csak akkor fut ha van cover
    if ( !document.getElementById('cover') ) { return; }

    const siteHeader = document.getElementById('site-header');
    const cover = document.getElementById('cover');
    let viewportHeight = document.documentElement.clientHeight;
    let contentTop = document.getElementById('site-content').getBoundingClientRect().top;
    let footerHeight = document.getElementById('site-footer').offsetHeight;

    viewportHeight - contentTop < footerHeight ? cover.style.zIndex = 0 : cover.style.zIndex = -1;

    devSays(identity,3,"viewportHeight - contentTop",viewportHeight - contentTop);
    devSays(identity,3,"footerHeight:",footerHeight);
}



// ha a cover alja kilog a viewportbol, behozza a cover footerjet a kepbe
// const coverFooterVerticalPosition=()=> {

//     const identity = "Cover's Footer Pos. Set."

//     //csak akkor fut ha van cover
//     if ( !document.getElementById('cover') ) { return; }

//     let coverFooter = document.querySelector('#cover > footer')
//     let coverBottom = document.getElementById('cover').getBoundingClientRect().bottom;
//     let viewportHeight = document.documentElement.clientHeight;

//     coverBottom - viewportHeight <= 0 ? coverFooter.style.bottom = 0 : coverFooter.style.bottom = coverBottom - viewportHeight + "px";

//     devSays(identity,1,'coverBottom - viewportHeight',coverBottom - viewportHeight);
//     devSays(identity,1,'coverBottom',coverBottom);
//     devSays(identity,1,'viewportHeight',viewportHeight);

// }



//negativ margot tesz a slider tetejere, hogy rafedjen a header 
const sliderMarginTop =()=> {

    //csak akkor fut ha van cover
    if ( !document.getElementById('cover') ) { return; }

    const identity = "Slider Margin Top"

    const headerHeight = document.querySelector('#header-cover > .container-full').offsetHeight;

    cover.style.marginTop = headerHeight*-1+"px";
    devSays(identity,2,'Set to',headerHeight*-1,"px");

}







const barathLayout = {
    _headerId: "site-header",
    _coverId: "cover",
    _contentId: "site-content",
    _footerId: "site-footer",
    _headerTransparentDisabled: false,
    _headerTransitionDisabled: false,
    _headerMaxOpacity: 90,
    contentMarginTop () {
        if ( !document.getElementById(this._coverId) ) { 
            //ha nincs cover
            const headerHeight = document.getElementById(this._headerId).offsetHeight;
            document.getElementById(this._contentId).style.marginTop = headerHeight+"px";
            return;
        } else {
            let sliderHeight = document.getElementById(this._coverId).offsetHeight;
            if (isSingleWorkPage()) {
                sliderHeight += 32;
            }
            document.getElementById(this._contentId).style.marginTop = sliderHeight+"px";
        }

    },
    contentMarginBottom () {
        // content margin bottom based on footer height
        let contentMB = document.getElementById(this._footerId).offsetHeight;
        if (isSingleWorkPage()) {
            contentMB -= 200;
        }
        document.getElementById(this._contentId).style.marginBottom = contentMB + "px";
    },
    headerTransparent(state) {
        let header = document.getElementById(this._headerId);
        if (state == 1) {
            header.classList.add("bg-opacity-0");
            header.classList.remove("bg-opacity-"+this._headerMaxOpacity)
            return state;
        } else if (state == -1){
            header.classList.add("bg-opacity-"+this._headerMaxOpacity);
            header.classList.remove("bg-opacity-0")
            return state;
        } else  {
            state = 0;
            return state;
        }

    },
    headerTransition(state) {
        let header = document.getElementById(this._headerId);
        if (state == 1) {
            header.classList.add("transition-colors");
            header.classList.add("duration-300");
            return state;
        } else if (state == -1){
            header.classList.remove("transition-colors");
            header.classList.remove("duration-300");
            return state;
        } else  {
            state = 0;
            return state;
        }
    },
    disableHeaderTransparent(param,transition) {
        if (typeof(transition) === 'undefined') {
            transition = 0;
        }
        this._headerTransparentDisabled = param;
        this.refreshHeaderStyle(transition);
    },
    headerContentIntersection() {
        headerBottom = document.getElementById(this._headerId).getBoundingClientRect().bottom;
        contentTop = document.getElementById(this._contentId).getBoundingClientRect().top;
        if (contentTop > headerBottom) {
            return false;
        } else {
            return true;
        }
    },
    refreshHeaderStyle(transition) {
        let transparency = 0;
        if ( this._headerTransparentDisabled ) {
            transparency = -1;
        } else if ( this.headerContentIntersection() ) {
            transparency = -1;
        } else {
            transparency = 1;
        }
        this.headerTransition(transition);
        this.headerTransparent(transparency);

    },
    setHeaderStyleAtScroll () {
        let that = this;
        window.addEventListener('scroll', function(){
            that.refreshHeaderStyle();
        });
    },

    refreshCoverVisibility() {
      if (document.getElementById('cover')) {
          if (window.scrollY > window.innerHeight * 1.5) {
              document.getElementById('cover')?.classList.add('invisible');
              document.getElementById('cover-footer')?.classList.add('hidden');
              document.getElementById('scrollarrow')?.classList.remove('xl:visible');
          } else {
              document.getElementById('cover')?.classList.remove('invisible');
              document.getElementById('cover-footer')?.classList.remove('hidden');
              document.getElementById('scrollarrow')?.classList.add('xl:visible');
          }
      }
    },

    refreshFooterVisibility() {
        // on long pages only (longer that 2 windows)
        if (document.body.clientHeight >  window.innerHeight * 2) {
            // show footer if we scroll down enough
            if (window.scrollY < window.innerHeight * 0.5) {
                document.getElementById('site-footer')?.classList.add('invisible');
                document.getElementById('to-the-top')?.classList.add('invisible');
            } else {
                document.getElementById('site-footer')?.classList.remove('invisible');
                document.getElementById('to-the-top')?.classList.remove('invisible');
            }
        }
    },

    setCoverHideOnScroll () {
        /* hide cover when scrolled down enough; it will show in ios bouncy scroll otherwise */
        let that = this;
        window.addEventListener('scroll', function(){
            that.refreshCoverVisibility();
            that.refreshFooterVisibility();
        });
    },

    //Slider Footer Position
    sfpInit(sliderId) {
        //Slider Footer Position - Init
        this.sfpData.id = sliderId.trim();
        let that = this;
        // dom betoltes utan csakkoljuk, hogy jelen vannak e a resztvevok
        if ( this.sfpRefresh(true) >= 0 ) {
            this.sfpSet();
            this.sfpWatch();
        } else {
            console.log('nincs slider vagy slider footer');
        }

    },
    sfpRefresh(hard) {

        // Slider Footer Position - frissitjuk az datokat
        if (hard) {
            this.sfpData.slider = document.getElementById(this.sfpData.id);
            this.sfpData.footer = document.querySelector('#' + this.sfpData.id + ' footer');
            if (this.sfpData.slider == null || this.sfpData.footer == null) {
                return -1;
            } else {
                this.sfpData.sliderHeight = this.sfpData.slider.offsetHeight;
                this.sfpData.footerBottom = this.sfpData.footer.getBoundingClientRect().bottom - window.scrollY;
                this.sfpData.viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                return 1;
            }
        } else {
            // this.sfpData.sliderBottom = this.sfpData.slider.getBoundingClientRect().bottom - window.scrollY;
            this.sfpData.sliderHeight = this.sfpData.slider.offsetHeight;
            this.sfpData.footerBottom = this.sfpData.footer.getBoundingClientRect().bottom - window.scrollY;
            this.sfpData.viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            return 0;
        }
    },
    sfpSet() {

        //beallitjuk a slider footer poziciojat
        if (this.sfpData.sliderHeight > this.sfpData.viewportHeight) {
            this.sfpData.footer.style.bottom = 0;
        } else {
            this.sfpData.footer.style.bottom = this.sfpData.viewportHeight - this.sfpData.sliderHeight +"px";
        }

    },
    sfpWatch() {

        //figyeljuk a resize es scroll esemenyeket, futtatjuk a refreshFuction-ben talalhato fuggvenyeket
    
        let that = this;
        let timer = 0;

        const refreshFunctions =()=> {
            //esemenykor ezeket futtatjuk:
            that.sfpRefresh();
            that.sfpSet();
        }

        //beallitjuk az esemeny figyeleseket
        window.addEventListener('resize', function() {
            clearTimeout(timer);
            timer = setTimeout(refreshFunctions, 400);
        });
        window.addEventListener('scroll', function(){
            refreshFunctions();
        });
    },
    sfpData: {
        id: '',
        slider: {},
        // sliderBottom: 0,
        sliderHeight: 0,
        footer: {},
        viewportHeight: 0
    },
    setSliderNavPosition(sliderId,top,bottom) {
        let sliderNav = document.querySelector('#' + sliderId +' div[data-glide-el="controls"]');
        if (sliderNav == null) {
            return;
        }
        sliderNav.style.top = parseInt(top) +"px";
        sliderNav.style.bottom = parseInt(bottom) + "px";
        if ( document.getElementById(sliderId).offsetHeight >= njq.viewportHeight() ) {
            sliderNav.style.position = "fixed";
        } else {
            sliderNav.style.position = "absolute";
        }
    },
    alignSubmenuPosition(submenuId,mod) {

        if (typeof(mod) !== "number") { mod = 0; }
        let parent = document.getElementById(submenuId + '-switch');
        let parentBox = parent.getBoundingClientRect();
        let subPanel = document.querySelector('#' + submenuId + ' .n_slide-in-submenu');

        subPanel.style.position = 'relative';
        subPanel.style.left = Math.floor(parentBox.x) + mod + 'px';
        subPanel.style.maxWidth = njq.viewportWidth() - Math.floor(parentBox.x) + 16 + 'px';

    },
    alignPandaAside() {

        const header = document.getElementById('panda-main-header');
        const modifier = "10rem";
        const aside = document.querySelector('#panda-main-header + aside');

        if(header === null || aside === null) { return; }

        aside.style.top = "calc(" + header.offsetHeight + "px + " + modifier + ")";

    }
}




